import { ErrorFallback } from '@takaro/lib-components';

export const DefaultErrorComponent = () => {
  return <ErrorFallback />;
};
